module.exports = __webpack_public_path__ + "static/media/ipActive.cb480ad7.svg";